module.exports = __webpack_public_path__ + "static/media/sidebar-11.d9f30850.png";